import React from 'react';

// Mise en forme minimale pour les descriptions d'événements de la main
// courante : **gras**, __souligné__, *italique*, et les retours à la ligne
// sont toujours respectés à l'affichage (contrairement à du texte brut dans
// un <p>). Volontairement très simple (pas d'imbrication, pas de librairie
// WYSIWYG) : stocké comme texte brut, donc compatible avec les événements
// existants. L'alternative **...** est testée avant *...* dans la regex :
// à une position "**", elle l'emporte toujours, donc "**gras**" n'est jamais
// mal interprété comme "*" + "gras" + "**".
const FORMAT_REGEX = /(\*\*.+?\*\*|\*.+?\*|__.+?__)/gs;

export const FormattedText = ({ text, className = '' }) => {
  if (!text) return null;
  const parts = text.split(FORMAT_REGEX);
  return (
    <span className={`whitespace-pre-wrap ${className}`}>
      {parts.map((part, i) => {
        if (/^\*\*.+\*\*$/s.test(part)) return <strong key={i}>{part.slice(2, -2)}</strong>;
        if (/^__.+__$/s.test(part)) return <u key={i}>{part.slice(2, -2)}</u>;
        if (/^\*.+\*$/s.test(part)) return <em key={i}>{part.slice(1, -1)}</em>;
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
};

// Entoure la sélection courante d'un <textarea> avec le marqueur donné (ou
// l'insère à la position du curseur s'il n'y a pas de sélection), puis rend
// le focus au textarea avec la sélection repositionnée sur le texte entouré -
// utilisé par les boutons Gras/Souligné de la barre d'outils.
export const wrapTextareaSelection = (textareaRef, value, onChange, marker) => {
  const el = textareaRef.current;
  if (!el) return;
  const start = el.selectionStart ?? value.length;
  const end = el.selectionEnd ?? value.length;
  const selected = value.slice(start, end) || 'texte';
  const next = `${value.slice(0, start)}${marker}${selected}${marker}${value.slice(end)}`;
  onChange(next);
  requestAnimationFrame(() => {
    el.focus();
    el.setSelectionRange(start + marker.length, start + marker.length + selected.length);
  });
};
